<template>
  <el-dialog
    v-model="showDialogAddQueryConfiguration"
    :title="`${
      typeForm === 'createForm'
        ? $t('t_add_query_configuration')
        : $t('t_update_query_configuration')
    }`"
    width="500"
    align-center
    :close-on-click-modal="false"
    :before-close="closeDialog"
  >
    <el-form
      ref="formRef"
      label-position="left"
      label-width="160px"
      :model="form"
    >
      <el-form-item
        :label="$t('t_query_configuration_user')"
        prop="user_id"
        :rules="[Validate.requiredChange]"
      >
        <el-select
          v-model="form.user_id"
          filterable
          :placeholder="$t('t_query_configuration_select_user')"
          style="width: 100%"
          :disabled="typeForm === 'updateForm'"
        >
          <el-option
            v-for="item in usersList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('t_query_configuration_limit')"
        :rules="
          typeForm === 'updateForm'
            ? [
                {
                  validator: validatePositiveInteger,
                  trigger: ['blur', 'change'],
                },
              ]
            : [
                Validate.required,
                {
                  validator: validatePositiveInteger,
                  trigger: ['blur', 'change'],
                },
              ]
        "
        prop="limit"
      >
        <el-input-number
          v-model="form.limit"
          :min="0"
          :step="1"
          controls-position="right"
          step-strictly
          autocomplete="off"
          clearable
          :placeholder="$t('t_query_configuration_limit_placeholder')"
          style="width: 180px"
        />
      </el-form-item>
      <div style="text-align: center; margin-top: 20px">
        <el-button type="primary" @click="onSubmit">{{
          typeForm === "createForm" ? $t("t-add") : $t("t-update")
        }}</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script setup>
import { ref, reactive, defineEmits, defineExpose } from "vue";
import MethodService from "../../service/MethodService";
import DataForm from "./dataCauHinhTruyVan";
import Validate from "../../service/ValidService";
import mushroom from "cem-primary-api";
import LanguageService from "../../service/LanguageService";
import toastr from "toastr";

import { useI18n } from "vue-i18n";
const { t } = useI18n();
const emit = defineEmits(["success"]);
const formRef = ref(null);
const showDialogAddQueryConfiguration = ref(false);
const form = reactive(MethodService.copyObject(DataForm.dataForm));
const typeForm = ref("createForm");
const usersList = ref([]); // danh sách người dùng
const validatePositiveInteger = (rule, value, callback) => {
  if (!Number.isInteger(value) || value < 0) {
    callback(
      new Error(
        LanguageService?.lang?.valid_checkNumber_integer ??
          "Vui lòng nhập số nguyên"
      )
    );
  } else {
    callback();
  }
};
const open = (props) => {
  typeForm.value = props.typeFormProps || "createForm";
  usersList.value = props.usersListProps || [];
  if (formRef.value) {
    formRef.value.resetFields();
  }

  form.id = props.dataRowProps?.id;
  form.user_id = props.dataRowProps?.user_id;
  form.limit = props.dataRowProps?.limit;

  console.log("form", props.dataRowProps);

  showDialogAddQueryConfiguration.value = true;
};
const createApiRequestLimitAsync = async () => {
  try {
    const response = await mushroom.api_request_limit.createAsync(form);
    if (response.result) {
      toastr.success(t("toastr_add_success"));
      emit("success");
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
    MethodService.showError(e.code);
  }
};
const updateApiRequestLimitAsync = async () => {
  try {
    const response = await mushroom.api_request_limit.partialUpdateAsync({
      id: form.id,
      limit: form.limit || 0,
    });
    if (response.result) {
      toastr.success(t("toastr_update_success"));
      emit("success");
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
    MethodService.showError(e.code);
  }
};
const onSubmit = () => {
  formRef.value.validate(async (valid) => {
    if (!valid) {
      return;
    }
    typeForm.value === "createForm"
      ? await createApiRequestLimitAsync()
      : await updateApiRequestLimitAsync();
    showDialogAddQueryConfiguration.value = false;
  });
};

defineExpose({
  open,
});
</script>
